module.exports = __webpack_public_path__ + "assets/2f55cddc8eb85b63ee5b4ce0e5488230.js";